import type { ZodError } from 'zod';

export function convertZodErrorsIntoMap<T>(
  error: ZodError<T>,
): Partial<Record<keyof T, { code: string; message: string }>> {
  const map: Partial<Record<keyof T, { code: string; message: string }>> = {};

  error.errors.forEach((error) => {
    const path = error.path.join('.');

    if (map[path]) return;

    map[path] = {
      code: error.code,
      message: error.message,
    };
  });

  return map;
}
